import React, { useMemo, useState } from "react";
import {
  ButtonGroup,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import cx from "classnames";
import { Icon, Spinner } from "components";
import { topologyConfig } from "components/Topology/configs/topologyConfig";
import {
  useIsFetching,
  usePossibleTopologyActions,
  useTopologyOperation,
  useWizardActions,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";
import { AddButtonOption } from "./AddButtonOption";

export const AddButton = React.memo(
  ({ classNames, options = [], topologyNodeId, topologyAction }) => {
    const topologyActions = usePossibleTopologyActions();

    const isActionFetching = useIsFetching();
    const topologyOperation = useTopologyOperation();
    const { invokeTopologyAction } = useWizardActions();
    const { addBtnWidth, addBtnHeight } = topologyConfig;

    const { title, action } = useMemo(
      () => (topologyActions && topologyActions[topologyAction]) || {},
      [topologyAction, topologyActions],
    );

    const [showLoader, setShowLoader] = useState(false);

    const handleAddComponent = (parameters) => {
      setShowLoader(true);
      invokeTopologyAction({
        action,
        sourceId: topologyNodeId,
        parameters,
      }).then(() => setShowLoader(false));
    };

    const disabled = useMemo(
      () => isActionFetching || !!topologyOperation?.kind,
      [isActionFetching, topologyOperation?.kind],
    );

    return (
      <ButtonGroup
        className={cx(
          "d-flex position-relative align-items-center w-100 h-100",
          classNames,
        )}
        style={{ width: addBtnWidth, height: addBtnHeight }}
      >
        <UncontrolledDropdown direction="end" disabled={disabled}>
          <div
            className="border rounded"
            data-test-parent-id={topologyNodeId}
            data-test-btn-action={title}
          >
            <DropdownToggle
              className="d-flex align-items-center search-button"
              color="transparent"
            >
              {showLoader && (
                <div
                  className="position-absolute pt-1"
                  style={{
                    top: "50%",
                    transform: "translate(50%, -50%)",
                    right: "50%",
                  }}
                >
                  <Spinner className="loader" size="xs" color={"primary"} />
                </div>
              )}
              {title?.startsWith("+") ? (
                <>
                  <Icon
                    iconName="plus-regular"
                    prefix="trox"
                    className="me-2"
                  />
                  {title.replace(/^\+ ?/, "")}
                </>
              ) : (
                <>{title}</>
              )}
            </DropdownToggle>
          </div>
          <DropdownMenu>
            {options.length &&
              options.map((option, key) => (
                <AddButtonOption
                  key={key}
                  option={option}
                  btnTitle={title}
                  handleAddComponent={handleAddComponent}
                />
              ))}
          </DropdownMenu>
        </UncontrolledDropdown>
      </ButtonGroup>
    );
  },
);
